import { render, staticRenderFns } from "./hcrmdzw.vue?vue&type=template&id=768bcfb4&scoped=true&"
import script from "./hcrmdzw.vue?vue&type=script&lang=js&"
export * from "./hcrmdzw.vue?vue&type=script&lang=js&"
import style0 from "./hcrmdzw.vue?vue&type=style&index=0&id=768bcfb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768bcfb4",
  null
  
)

export default component.exports